import { render, staticRenderFns } from "./collect-list.scene.vue?vue&type=template&id=b65b5942"
import script from "./collect-list.scene.ts?vue&type=script&lang=ts&external"
export * from "./collect-list.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./collect-list.scene.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
